import { IAffiliate } from '@adminPortal/_common/_interfaces/IAffiliate';
import { IGetAffiliateListRequestData } from '@adminPortal/_common/_interfaces/IGetAffiliateListRequestData';
import { ITransaction } from '@adminPortal/_common/_interfaces/ITransaction';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { AffiliateActions } from './affiliate.actions';

export const affiliateFeatureKey = 'affiliate';

export interface AffiliateState {
  requestData: IGetAffiliateListRequestData | null;
  totalItems: number;
  affiliateList: IAffiliate[];
  transactions: ITransaction[];
  loading: boolean;
  error: any;
}

export const initialState: AffiliateState = {
  requestData: null,
  totalItems: 0,
  affiliateList: [],
  transactions: [],
  loading: false,
  error: null,
};

export const affiliateFeature = createFeature({
  name: affiliateFeatureKey,
  reducer: createReducer(
    initialState,
    on(
      AffiliateActions.createNewAffiliate,
      AffiliateActions.loadAffiliateList,
      AffiliateActions.deleteAffiliate,
      AffiliateActions.saveAffiliate,
      (state) => ({
        ...state,
        loading: true,
        error: null,
      })
    ),
    on(
      AffiliateActions.createNewAffiliateFailure,
      AffiliateActions.loadAffiliateListFailure,
      AffiliateActions.deleteAffiliateFailure,
      AffiliateActions.saveAffiliateFailure,
      (state, { error }) => ({
        ...state,
        loading: false,
        error,
      })
    ),
    on(AffiliateActions.loadAffiliateList, (state, { requestData }) => ({
      ...state,
      requestData,
      loading: true,
      error: null,
    })),
    on(AffiliateActions.loadAffiliateListSuccess, (state, { affiliateList }) => ({
      ...state,
      affiliateList: affiliateList,
      loading: false,
      error: null,
    })),
    on(AffiliateActions.deleteAffiliateSuccess, AffiliateActions.saveAffiliateSuccess, (state) => ({
      ...state,
      loading: false,
      error: null,
    })),
    on(AffiliateActions.loadTransactions, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(AffiliateActions.loadTransactionsSuccess, (state, { transactions }) => ({
      ...state,
      transactions,
      loading: false,
      error: null,
    })),
    on(AffiliateActions.loadTransactionsFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(AffiliateActions.loadMyTransactions, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(AffiliateActions.loadMyTransactionsSuccess, (state, { transactions }) => ({
      ...state,
      transactions,
      loading: false,
      error: null,
    })),
    on(AffiliateActions.loadMyTransactionsFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }))
  ),

  extraSelectors: ({ selectAffiliateState }) => ({
    selectAffiliateTotalItems: createSelector(
      selectAffiliateState,
      (selectAffiliateStateData) => selectAffiliateStateData.totalItems
    ),
    selectAffiliateRequest: createSelector(
      selectAffiliateState,
      (selectAffiliateStateData) => selectAffiliateStateData.requestData
    ),
    selectAffiliatesList: createSelector(
      selectAffiliateState,
      (selectAffiliateStateData) => selectAffiliateStateData.affiliateList
    ),
  }),
});
